
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.843 8.03A9.168 9.168 0 006.5 5.5c-2.46 0-4.69.959-6.343 2.53a.54.54 0 000 .763L1.5 10.137a.551.551 0 00.396.162.53.53 0 00.368-.157c.428-.4.91-.737 1.441-1.002a.54.54 0 00.303-.488V6.973a8.051 8.051 0 012.492-.39c.867 0 1.706.136 2.492.39v1.68c0 .216.124.4.303.487.53.265 1.013.601 1.44 1.002a.531.531 0 00.37.157.551.551 0 00.395-.162l1.343-1.344a.54.54 0 000-.764zM3.52 1.98L6.5 4.957l3.792-3.791L9.75.625 6.5 3.875 4.062 1.437h1.896V.625h-3.25v3.25h.813V1.979z","fill":"#263238"}})])
          )
        }
      }
    